const state = {
  disclaimers: {
    byId: {},
    allIds: []
  },
  defaultDisclaimerEnabled: true
};
export default state;